import { useTranslation } from 'react-i18next'

import { DatePicker, Input, Label } from '@mercai/clever'

import { SupplyInventoryTransactionFormProps } from './supply-inventory-transaction-form.types'

import styles from './supply-inventory-transaction-form.module.css'

export const SupplyInventoryTransactionForm = ({
  values,
  errors,
  onChangeValues,
}: SupplyInventoryTransactionFormProps) => {
  const { t } = useTranslation('componentsSupplyInventoryTransactionForm')

  const onHandleValues = (
    key: string,
    val: string | number | boolean | null | undefined,
  ) => {
    onChangeValues({ ...values, [key]: val })
  }

  return (
    <div>
      <div className={styles.content}>
        <div className={styles['content-form']}>
          <div>
            <Label>{t('internalCodeLabel')}</Label>
            <Input
              placeholder={t('internalCodePlaceholder')}
              value={values?.internalCode}
              onChange={(newValue) => onHandleValues('internalCode', newValue)}
              error={errors?.internalCode as string}
            />
          </div>

          <div>
            <Label>{t('batchCodeLabel')}</Label>
            <Input
              placeholder={t('batchCodePlaceholder')}
              value={values?.batchCode}
              onChange={(newValue) => onHandleValues('batchCode', newValue)}
              error={errors?.batchCode as string}
            />
          </div>
          <div>
            <Label>{t('entryDateLabel')}</Label>
            <DatePicker
              placeholder={t('entryDatePlaceholder')}
              value={values?.entryDate}
              onChange={(newValue) =>
                onHandleValues('entryDate', !newValue ? null : newValue)
              }
              error={errors?.entryDate as string}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
